import { render, staticRenderFns } from "./CalendarTwoColumnGrid.vue?vue&type=template&id=0ff5761b&scoped=true"
import script from "./CalendarTwoColumnGrid.vue?vue&type=script&lang=js"
export * from "./CalendarTwoColumnGrid.vue?vue&type=script&lang=js"
import style0 from "./CalendarTwoColumnGrid.vue?vue&type=style&index=0&id=0ff5761b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5761b",
  null
  
)

export default component.exports